"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeparturePickerMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _MobileDropdown = require("../MobileDropdown");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:
var IconStar = function IconStar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "star_svg__path1",
    d: "M12.633 19.484l-7.388 3.884 1.411-8.226L.679 9.316l8.26-1.2L12.633.631l3.694 7.485 8.26 1.2-5.977 5.826 1.411 8.226z"
  }));
};
IconStar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
}; // Interfaces:
var DeparturePickerMobile = exports.DeparturePickerMobile = function DeparturePickerMobile(props) {
  var departure = props.departure,
    onChangeDeparture = props.onChangeDeparture,
    departuresList = props.departuresList;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    chosenIndex = _useState4[0],
    setChosenIndex = _useState4[1];
  var popupLabel = 'Город вылета';
  var handleChoose = function handleChoose(val) {
    onChangeDeparture(val);
    setChosenIndex(departuresList.findIndex(function (value) {
      return value.name_ru === val.name_ru;
    }));
    setIsOpen(false);
  };
  var handleOpen = function handleOpen() {
    return setIsOpen(true);
  };
  var handleClose = function handleClose() {
    return setIsOpen(false);
  };
  var handleAnimationEnd = function handleAnimationEnd() {
    var _element$chosenIndex;
    var element = document.querySelectorAll(StyledButton.styledComponentId);
    (_element$chosenIndex = element[chosenIndex]) === null || _element$chosenIndex === void 0 || _element$chosenIndex.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_MobileDropdown.MobileDropdown, {
    popupLabel: popupLabel,
    dropdownLabel: departure.name_ru,
    submitButtonText: "",
    onControlClick: handleOpen,
    onCancel: handleClose,
    onAnimationEnd: handleAnimationEnd,
    open: isOpen,
    containerStyles: ContainerStyles,
    fullControl: true
  }, /*#__PURE__*/_react["default"].createElement("ul", null, departuresList.map(function (departureVal, index) {
    var isSelected = index === chosenIndex;
    return /*#__PURE__*/_react["default"].createElement(StyledDeparture, {
      key: departureVal.name_ru
    }, /*#__PURE__*/_react["default"].createElement(StyledButton, {
      type: "button",
      onClick: function onClick() {
        return handleChoose(departureVal);
      },
      selected: isSelected,
      highlighted: index < 2
    }, departureVal.name_ru, index < 1 && /*#__PURE__*/_react["default"].createElement(StyledIconStar, null)));
  })));
};
var StyledDeparture = _styledComponents["default"].li.withConfig({
  displayName: "DeparturePickermobile__StyledDeparture",
  componentId: "sc-j6agbu-0"
})(["&:hover{cursor:pointer;}"]);
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "DeparturePickermobile__StyledButton",
  componentId: "sc-j6agbu-1"
})(["border:none;height:48px;width:100%;padding-left:8px;text-align:left;font-size:16px;line-height:20px;&:hover{cursor:pointer;}font-weight:", ";color:", ";background-color:", ";"], function (_ref) {
  var highlighted = _ref.highlighted;
  return highlighted && 500;
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected && '#fff';
}, function (_ref3) {
  var theme = _ref3.theme,
    selected = _ref3.selected;
  return selected ? theme.colors.blue : 'transparent';
});
var StyledIconStar = (0, _styledComponents["default"])(IconStar).withConfig({
  displayName: "DeparturePickermobile__StyledIconStar",
  componentId: "sc-j6agbu-2"
})(["width:14px;height:14px;margin-bottom:-2px;margin-left:4px;fill:#d0021b;"]);
var ContainerStyles = (0, _styledComponents.css)(["&:after{height:50px;bottom:0;content:'';width:100%;position:fixed;background:linear-gradient( 180deg,rgba(255,255,255,0) 0%,#ffffff 100% );}"]);